import { makeStyles } from 'tss-react/mui';

export const useEllipsisStyles = makeStyles<{
  verticalAlign?: 'top' | 'middle' | 'bottom' | 'baseline';
}>()((theme, { verticalAlign } = {}) => ({
  ellipsis: {
    overflow: 'hidden',
    display: 'inline-block',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    width: '100%',
    verticalAlign,
  },
}));
